var map = {
	"./claim/1.png": 114,
	"./claim/10.png": 115,
	"./claim/11.png": 116,
	"./claim/12.png": 117,
	"./claim/13.png": 118,
	"./claim/14.png": 119,
	"./claim/15.png": 120,
	"./claim/16.png": 121,
	"./claim/17.png": 122,
	"./claim/18.png": 123,
	"./claim/19.png": 124,
	"./claim/2.png": 125,
	"./claim/20.png": 126,
	"./claim/21.png": 127,
	"./claim/22.png": 128,
	"./claim/23.png": 129,
	"./claim/24.png": 130,
	"./claim/25.png": 131,
	"./claim/26.png": 132,
	"./claim/27.png": 133,
	"./claim/28.png": 134,
	"./claim/29.png": 135,
	"./claim/3.png": 136,
	"./claim/30.png": 137,
	"./claim/4.png": 138,
	"./claim/5.png": 139,
	"./claim/6.png": 140,
	"./claim/7.png": 141,
	"./claim/8.png": 142,
	"./claim/9.png": 143,
	"./claim/tel.png": 28,
	"./employee/1.png": 144,
	"./employee/2.png": 145,
	"./employee/3.png": 146,
	"./health/1.png": 147,
	"./health/2.png": 148,
	"./icon/company.png": 149,
	"./icon/icon_chat.png": 52,
	"./icon/icon_grow.png": 50,
	"./icon/icon_product.png": 51,
	"./icon/icon_protect.png": 53,
	"./icon/individual.png": 90,
	"./icon/menu.png": 87,
	"./icon/tel.png": 150,
	"./liability/1.png": 151,
	"./liability/2.png": 152,
	"./liability/3.png": 153,
	"./liability/4.png": 154,
	"./miscellaneous/1.png": 155,
	"./miscellaneous/2.png": 156,
	"./miscellaneous/3.png": 157,
	"./motor/1.png": 158,
	"./motor/2.png": 159,
	"./partner/AIA.png": 54,
	"./partner/AIG.png": 55,
	"./partner/AXA.png": 56,
	"./partner/Aioi.png": 57,
	"./partner/Bangkok.png": 58,
	"./partner/CHUBB.png": 59,
	"./partner/Charan.png": 60,
	"./partner/Cigna.png": 61,
	"./partner/Deves.png": 62,
	"./partner/Dhipaya.png": 63,
	"./partner/FPG.png": 64,
	"./partner/Falcon.png": 65,
	"./partner/Indara.png": 66,
	"./partner/IndaraPLC.png": 67,
	"./partner/Jaymart.png": 68,
	"./partner/KPI.png": 69,
	"./partner/KWG.png": 70,
	"./partner/LMG.png": 71,
	"./partner/MSIG.png": 72,
	"./partner/MuangThai.png": 73,
	"./partner/NSI.png": 74,
	"./partner/Navakij.png": 75,
	"./partner/New India.png": 76,
	"./partner/SouthEast.png": 77,
	"./partner/Sunday.png": 78,
	"./partner/THAIPAIBOON.png": 79,
	"./partner/THAIPAT.png": 80,
	"./partner/THAISRI.png": 81,
	"./partner/TSI.png": 82,
	"./partner/Thanachart.png": 83,
	"./partner/TokioMarine.png": 84,
	"./partner/Tune.png": 85,
	"./partner/Viriyah.png": 86,
	"./payment/account-backup.png": 160,
	"./payment/account.png": 91,
	"./personal/1.png": 161,
	"./purchase/health/logo.png": 162,
	"./purchase/health/qrcode_1.png": 163,
	"./purchase/health/qrcode_2.png": 164,
	"./purchase/motor/logo.png": 165,
	"./purchase/motor/qrcode_1.png": 166,
	"./purchase/other/logo.png": 167,
	"./purchase/saving/logo.png": 168,
	"./purchase/saving/qrcode_1.png": 169,
	"./purchase/travel/logo.png": 170,
	"./purchase/travel/qrcode_1.png": 171,
	"./travel/1.png": 172
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 243;